module.exports = __webpack_public_path__ + "static/media/college_rec_logo.6e2f0a4c.png";